module.exports = "../../../../platform/assets/pageMainIcon/industry_yewuchulilei8.svg";